import { render, staticRenderFns } from "./FourDay.vue?vue&type=template&id=4c9679d6&scoped=true&"
import script from "./FourDay.vue?vue&type=script&lang=js&"
export * from "./FourDay.vue?vue&type=script&lang=js&"
import style0 from "./FourDay.vue?vue&type=style&index=0&id=4c9679d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9679d6",
  null
  
)

export default component.exports